import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryOcPaymentList(requestBody) {
  return request({
    url: URL.act.ocPayment.query,
    method: 'post',
    data: requestBody
  })
}

export function processOcPayment(requestBody) {
  return request({
    url: URL.act.ocPayment.process,
    method: 'post',
    data: requestBody
  })
}

export function receivedAmount(requestBody) {
  return request({
    url: URL.act.ocPayment.receivedAmount,
    method: 'post',
    data: requestBody
  })
}

export function abnormal(requestBody) {
  return request({
    url: URL.act.ocPayment.abnormal,
    method: 'post',
    data: requestBody
  })
}
